import {
  AccountProviderConfigurationFragment,
  BankAccountRoutesQuery,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { buildBankAccountHeaderComponentProps } from './resources_headers/bank_account'

type AccountsNavigation = {
  accountId: {
    transactions: { fullPath: (params: { id: string }) => string }
    cards: { fullPath: (params: { id: string }) => string }
    card_payments: { fullPath: (params: { id: string }) => string }
  }
}

const buildBankAccountSubnavigationRoutes = (
  accountsNavigation: AccountsNavigation,
  providerConfiguration: AccountProviderConfigurationFragment | null | undefined,
  accountId: string
) => {
  const hasCards = providerConfiguration?.services.includes('card_management') ?? false
  return [
    {
      id: 'transactions',
      title: i18n.t('banking.bank_account.tabs.transactions'),
      href: accountsNavigation.accountId.transactions.fullPath({ id: accountId }),
      isVisible: true,
    },
    {
      id: 'cards',
      title: i18n.t('banking.bank_account.tabs.cards'),
      href: accountsNavigation.accountId.cards.fullPath({ id: accountId }),
      isVisible: hasCards,
    },
    {
      id: 'card_payments',
      title: i18n.t('banking.bank_account.tabs.card_payments'),
      href: accountsNavigation.accountId.card_payments.fullPath({ id: accountId }),
      isVisible: hasCards,
    },
  ]
}

export const buildBankAccountMeta = (
  navigation: Navigation<NavigationPaths>,
  data: BankAccountRoutesQuery
) => {
  const canSeeAccountPage = data?.banking?._policies?.bankAccountsSeeDetailPage?.can ?? false
  const bankAccount = data?.banking?.bankAccount
  const title = bankAccount?.accountAlias ?? bankAccount?.accountNumber.slice(-4) ?? ''
  const headerComponentProps = buildBankAccountHeaderComponentProps(canSeeAccountPage, bankAccount)
  const providerConfiguration = bankAccount?.account.providerConfiguration
  const accountsNav: AccountsNavigation = navigation.finance.treasury?.banking?.accounts
  const subNavigation = buildBankAccountSubnavigationRoutes(
    accountsNav,
    providerConfiguration,
    bankAccount?.id + ''
  )
  return {
    title,
    headerComponentProps,
    subNavigation,
  }
}
